/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Blog_DescriptionInputs */

const en_meta_blog_description = /** @type {(inputs: Meta_Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practical guides to choosing, building and running useful AI systems.`)
};

const lv_meta_blog_description = /** @type {(inputs: Meta_Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praktiski norādījumi, kā izvēlēties, izveidot un uzturēt noderīgas AI sistēmas.`)
};

/**
* | output |
* | --- |
* | "Practical guides to choosing, building and running useful AI systems." |
*
* @param {Meta_Blog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_blog_description = /** @type {((inputs?: Meta_Blog_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Blog_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_blog_description(inputs)
	return en_meta_blog_description(inputs)
});